define("Smile_ElasticsuiteTracker/js/user-consent",["jquery","mage/cookies"],function(e){return function(i){return 0==i.cookieRestrictionEnabled||null!==e.mage.cookies.get(i.cookieRestrictionName)}});
